/**
 * NOTIF-005 (F-145) — why a line goes back: ours or the client's. Required on every send-back
 * (server: DdWorkflowLine::SENT_BACK_CAUSES); stored on the line as `sentBack.cause`, named in
 * the dd.sent_back notification, the chip tooltip and the notices.
 */
export type SendBackCause = 'internal_error' | 'client_request'

export interface SendBackCauseOption {
  value: SendBackCause
  label: string
  hint: string
}

export const SEND_BACK_CAUSES: readonly SendBackCauseOption[] = [
  {
    value: 'internal_error',
    label: 'Our mistake',
    hint: 'Something on our side was wrong or missing'
  },
  {
    value: 'client_request',
    label: 'Client request',
    hint: 'The client changed or added something'
  }
]

export function isSendBackCause(value: unknown): value is SendBackCause {
  return SEND_BACK_CAUSES.some((c) => c.value === value)
}

/** The option's label, or null for a line sent back before the cause existed. */
export function sendBackCauseLabel(cause: string | null | undefined): string | null {
  return SEND_BACK_CAUSES.find((c) => c.value === cause)?.label ?? null
}
